import React, {useEffect, useRef} from 'react';

import LoadingBar from 'react-top-loading-bar';

const LoadingScreen = () => {
  const ref = useRef(null);

  useEffect(() => {
    ref.current.continuousStart(0, 50);
  },[]);

  return(
    <div className="fixed h-full w-full top-0 left-0" style={ {zIndex: 99999 } }>
      <LoadingBar color='#f33d63' ref={ ref } height={ 3 } loaderSpeed={ 1500 } shadow={ false } />

      {/*<div className="h-full w-full flex items-center justify-center">*/}
      {/*  <div className="loader-wrap">*/}
      {/*    <div className="w-full h-full flex items-center justify-center animate-spin">*/}
      {/*      <FontAwesomeIcon icon={ 'spinner' } color={ '#fff' } size={ '2x' } />*/}
      {/*    </div>*/}
      {/*    <div className="loader" />*/}
      {/*  </div>*/}
      {/*</div>*/}
    </div>
  );
};

export default LoadingScreen;